<div class="promo-swipe" #track>
  <span class="promo-swipe__circle" #circle [class.dragging]="dragging"
    [style.transform]="'translateX(' + offset + 'px)'"
    (pointerdown)="onDown($event)" (pointermove)="onMove($event)"
    (pointerup)="onUp()" (pointercancel)="onUp()">
    <svg xmlns="http://www.w3.org/2000/svg">
      <path class="arrow" fill-rule="evenodd"
        d="M12.551,8.707 L5.256,1.412 C4.270,0.426 2.672,0.426 1.686,1.412 C0.701,2.398 0.701,3.996 1.686,4.981 L7.197,10.492 L1.686,16.003 C0.701,16.988 0.701,18.587 1.686,19.572 C2.672,20.558 4.270,20.558 5.256,19.572 L12.551,12.276 C13.537,11.292 13.537,9.693 12.551,8.707 Z"
        transform="translate(5, 1)" />
    </svg>
  </span>
  <span class="promo-swipe__text" [style.opacity]="1 - progress">{{ 'slideToConnectEdim' | translate }}</span>
</div>
